import tracking from '../utils/tracking';

export default class PostRenderedTracking {

  static propertyFinder(e: Event, attribute: string) {
    if (e && e.target && e.target.hasAttribute(`[${attribute}]`)) {
      return e.target.getAttribute(attribute);
    } else if (e && e.target && e.target.closest(`[${attribute}]`)) {
      return e.target.closest(`[${attribute}]`).dataset.eventContainer;
    }
    return '';
  }

  static track(e: Event) {
    const target = e.target ? e.target : {tagName: '', value: ''};
    let trackLabel = '';
    switch (target.tagName) {
      case 'INPUT':
        trackLabel = target.value;
        break;
      case 'SELECT':
        trackLabel = target.value;
        break;
      default:
        trackLabel = target.innerText;
        break;
    }
    tracking.trackEvent('clicked', {
      eventContainer: this.propertyFinder(e, 'data-event-container'),
      eventComponent: this.propertyFinder(e, 'data-event-component'),
      eventColumn: this.propertyFinder(e, 'data-event-column'),
      parentLabel: this.propertyFinder(e, 'data-track-parent-label'),
      uuid: this.propertyFinder(e, 'uuid'),
      label: trackLabel ? trackLabel.trim() : '',
      schemaVersion: 1
    });
  }

}
